import React from "react";
import { Link } from "react-router-dom";
import { Heart } from "lucide-react";
import { BRAND, EVENTS } from "../data/content";

const Footer = () => {
    return (
        <footer
            data-testid="site-footer"
            className="relative bg-ink text-paper mt-24 paper-noise"
        >
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-16 pb-10">
                <div className="grid grid-cols-1 md:grid-cols-4 gap-10">
                    <div className="md:col-span-2 space-y-4">
                        <div className="flex items-center gap-3">
                            <img
                                src={BRAND.logo}
                                alt="PopIn logo"
                                className="h-10 w-auto bg-white p-1 rounded"
                            />
                            <span className="font-marker text-3xl text-paper">
                                PopInReviews
                                <span className="text-marker-red">.ca</span>
                            </span>
                        </div>
                        <p className="font-editorial italic text-xl text-paper/80 max-w-md leading-snug">
                            A scrapbook of real moments from real attendees.
                            Made for the awkward, the curious & the connectors.
                        </p>
                    </div>

                    <div>
                        <h4 className="font-marker text-lg text-paper mb-4">
                            Event reviews
                        </h4>
                        <ul className="space-y-2">
                            {EVENTS.map((e) => (
                                <li key={e.id}>
                                    <Link
                                        to={`/reviews/${e.id}`}
                                        data-testid={`footer-event-link-${e.id}`}
                                        className="font-sans text-sm text-paper/70 hover:text-marker-red transition-colors"
                                    >
                                        {e.shortName}
                                    </Link>
                                </li>
                            ))}
                        </ul>
                    </div>

                    <div>
                        <h4 className="font-marker text-lg text-paper mb-4">
                            Pop in
                        </h4>
                        <ul className="space-y-2">
                            <li>
                                <a
                                    href={BRAND.parentUrl}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    data-testid="footer-popin-link"
                                    className="font-sans text-sm text-paper/70 hover:text-marker-red transition-colors"
                                >
                                    letspopin.com
                                </a>
                            </li>
                            <li>
                                <a
                                    href={BRAND.parentUrl}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    data-testid="footer-try-link"
                                    className="font-sans text-sm text-paper/70 hover:text-marker-red transition-colors"
                                >
                                    Try the app
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>

                <div className="mt-12 pt-6 border-t border-paper/15 flex flex-col sm:flex-row items-center justify-between gap-4">
                    <p className="font-sans text-xs text-paper/55">
                        © {new Date().getFullYear()} PopInReviews.ca · A
                        community love letter to PopIn.
                    </p>
                    <p className="font-handwriting text-base text-paper/70 inline-flex items-center gap-1.5">
                        Built with{" "}
                        <Heart
                            size={14}
                            className="text-marker-red fill-marker-red"
                        />{" "}
                        for the Toronto event scene
                    </p>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
